export var NotificationType;
(function (NotificationType) {
    NotificationType["Success"] = "success";
    NotificationType["Danger"] = "danger";
    NotificationType["Warning"] = "warning";
    NotificationType["Info"] = "info";
    NotificationType["Progress"] = "progress";
})(NotificationType || (NotificationType = {}));
//# sourceMappingURL=notifications.enum.js.map